import { render, staticRenderFns } from "./GeneralinformationForm.vue?vue&type=template&id=331fc78c&"
import script from "./GeneralinformationForm.vue?vue&type=script&lang=js&"
export * from "./GeneralinformationForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports